import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField } from 'shared/react-admin/Fields';

export const BankOperationsShowTabsHistory: React.FC = () => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '275px' } } }}>
      <TableRowWrapper label="Дата создания">
        <DateTimeField inline source="createdAt" />
      </TableRowWrapper>
      <TableRowWrapper label="Дата редактирования комментария">
        <DateTimeField inline source="descriptionUpdatedAt" />
      </TableRowWrapper>
      <TableRowWrapper label="Дата аннулирования">
        <DateTimeField inline source="canceledAt" />
      </TableRowWrapper>
    </CardTable>
  );
};
